import Cookies from 'js-cookie';

const isClientSideAuth = () => {
	const hasAccessToken = Cookies.get('access-token');
	return Boolean(hasAccessToken);
};

export default isClientSideAuth;
